
import {Component, input, OnInit, ViewEncapsulation} from "@angular/core";

import {
  IAlertFeedbackController,
  IT_ALERT_FEEDBACK_CONTROLLER,
  MK_ALERT_FEEDBACK
} from "../_controllers/IAlertFeedbackController";
import {AlertFeedbackModel} from "../_models/AlertFeedbackModel";
import {AlertFeedbackController} from "../_controllers/alert-feedback.controller";
import {AbstractView} from "../../../views/AbstractView";
import {AlertData} from "../../../interfaces/domain/alert/AlertData";

@Component({
  selector: 'link-alert-feedback',
  templateUrl: './alert-feedback.view.html',
  styleUrls: ['./alert-feedback.view.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    { provide: IT_ALERT_FEEDBACK_CONTROLLER, useClass: AlertFeedbackController },
  ]
})
export class AlertFeedbackView extends AbstractView<IAlertFeedbackController> implements OnInit {

  alertData = input<AlertData | null>();

  protected model: AlertFeedbackModel;
  commentMessage: '' | undefined;
  thumb_up = input<any | undefined>();
  thumb_up_selected = input<any | undefined>();
  thumb_down = input<any | undefined>();
  thumb_down_selected = input<any | undefined>();

  constructor() {
    super(IT_ALERT_FEEDBACK_CONTROLLER);
    this.model = this.getController().getModel(MK_ALERT_FEEDBACK);
  }

  ngOnInit(): void {
    this.model.alertData$.set(this.alertData());
    this.model.currentFeedback$.set(this.alertData()?.currentFeedback!);
  }

  onNestedClick(event: MouseEvent) {
    event.stopPropagation();
  }

  selectFeedback(positive: string) {
    this.getController().handle("SelectFeedback", positive);
  }
}
